import React from "react";
import { OnlyOnPrint, PrintStyle } from "../../../designSystem/compositeComponents/Print";
import { ActionPlanView } from "../../../amorg-common";
import { H1, H2 } from "../../../designSystem/typography/Heading";
import { P, Small } from "../../../designSystem/typography/Body";
import { Flex } from "../../../designSystem/compositeComponents/FlexHelpers";
import { toDateString } from "../../../utils/date";
import { PublicPageProvider } from "../../_contexts/PublicPageContext";


type PrintActionPlanViewProps = {
    actionPlan: ActionPlanView,
    innerRef: React.Ref<HTMLDivElement>;
};

export default function PrintActionPlanPage (props: PrintActionPlanViewProps): JSX.Element 
{
    return (
        <PublicPageProvider>

            <OnlyOnPrint>
                <PrintStyle ref={props.innerRef}>
                    <Flex flexDirection="column" gap={16}>
                        <H1>{props.actionPlan.title}</H1>
                        <P>{props.actionPlan.description}</P>
                        <P>Ansvarlig: {props.actionPlan.owner?.fullName}</P>
                        {props.actionPlan.type === 'WPA' &&
                            <Flex flexDirection="column" gap={4}>
                                <P>Segmenter:</P>
                                <Flex flexDirection="row" gap={32}>
                                    {props.actionPlan.customData.segmentFilter.map((segment, i) => (
                                        <P key={i}>
                                            {segment.map(s => s.value).join(", ")}
                                        </P>
                                    ))}
                                </Flex>
                            </Flex>
                        }
                        <Flex flexDirection="column" gap={32}>
                            {props.actionPlan.topics.map((t) =>
                            {
                                return (
                                    <Flex flexDirection="column" gap={16} key={t.id}>
                                        <H2>{t.description}</H2>
                                        <Flex flexDirection="column" gap={8}>
                                            {t.actionPoints.map(ap =>
                                                <Flex flexDirection="column" gap={4} key={ap.id}>

                                                    <Flex flexDirection="row" gap={8} alignItems='flex-start'>
                                                        <input type="checkbox" checked={ap.done} readOnly />
                                                        <P>{ap.description}</P>
                                                    </Flex>

                                                    <Flex flexDirection="row" gap={8}>
                                                        <input type="checkbox" readOnly style={{ visibility: 'hidden' }} />
                                                        <Small>
                                                            Ejer: {ap.assignedUser !== null ? ap.assignedUser.fullName : <i>Ingen ejer angivet</i>}
                                                        </Small>
                                                        <Small>
                                                            Deadline: {ap.deadline !== null ? toDateString(new Date(ap.deadline)) : <i>Ingen deadline angivet</i>}
                                                        </Small>
                                                    </Flex>

                                                </Flex>)
                                            }
                                        </Flex>

                                    </Flex>
                                );
                            })}
                        </Flex>
                    </Flex>
                </PrintStyle>
            </OnlyOnPrint>
        </PublicPageProvider>
    );

}